import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { roundOpts, setRoundOpts } from '../lib/route';
import { getPlaces, activatePlace } from '../lib/pcHome';
import { rt, fill, placeName } from '../lib/roundText';

// round options: start (my location / first logger), back to start, one-tap switch between saved locations
export function RoundOpts({ pre }) {
  const [o, setO] = useState(roundOpts), [pl, setPl] = useState(getPlaces), x = rt();
  useEffect(() => {
    const a = () => setO(roundOpts()), b = () => setPl(getPlaces());
    window.addEventListener('giss-round-opts', a); window.addEventListener('giss-pc-home', b);
    return () => { window.removeEventListener('giss-round-opts', a); window.removeEventListener('giss-pc-home', b); };
  }, []);
  const pick = (p) => { activatePlace(p.id); toast.success(fill(x.switched, { n: placeName(p) })); };
  return (
    <div className="round-opts" data-testid={`${pre}-round-opts`}>
      <span className="ro-lbl">{x.start}:</span>
      <button type="button" className={`chip seg ${o.start === 'here' ? 'on' : ''}`} data-testid={`${pre}-start-here`} onClick={() => setRoundOpts({ start: 'here' })}>📍 {x.here}</button>
      <button type="button" className={`chip seg ${o.start === 'first' ? 'on' : ''}`} data-testid={`${pre}-start-first`} onClick={() => setRoundOpts({ start: 'first' })}>① {x.first}</button>
      <label className="chk-row ro-loop"><input type="checkbox" data-testid={`${pre}-loop`} checked={o.loop} onChange={(e) => setRoundOpts({ loop: e.target.checked })} /> ↩ {x.loop}</label>
      {o.start === 'here' && pl.list.length > 1 && (
        <span className="ro-places" data-testid={`${pre}-places`}>
          {pl.list.map((p) => <button key={p.id} type="button" className={`chip seg ${pl.active === p.id ? 'on' : ''}`} data-testid={`${pre}-place-${p.id}`} onClick={() => pick(p)}>{placeName(p)}</button>)}
        </span>
      )}
    </div>
  );
}
